var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("g-breadcrumb", {
        attrs: { paginas: _vm.paginaStatus.caminhoMigalha }
      }),
      _c(
        "q-card",
        [
          _c("q-card-main", [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-8 col-xs-6" },
                [
                  _c("g-input", {
                    ref: "refCodigo",
                    attrs: {
                      id: "refCodigo",
                      name: "refCodigo",
                      tipo: "text",
                      etiqueta: "Código",
                      validacao: "numeric",
                      desabilitar: true,
                      foco: false
                    },
                    model: {
                      value: _vm.paginaStatus.subAssunto.codSubassunto,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.paginaStatus.subAssunto,
                          "codSubassunto",
                          $$v
                        )
                      },
                      expression: "paginaStatus.subAssunto.codSubassunto"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-12 col-xs-12" },
                [
                  _c("g-autocomplete", {
                    ref: "refAssunto",
                    attrs: {
                      id: "refAssunto",
                      name: "refAssunto",
                      etiqueta: "Assunto",
                      valor: "codAssunto",
                      descricaoPrimaria: "desAssunto",
                      validacao: "required",
                      desabilitar: _vm.paginaStatus.desabilitarEdicao,
                      api: _vm.apiAssunto
                    },
                    model: {
                      value: _vm.paginaStatus.subAssunto.assunto.codAssunto,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.paginaStatus.subAssunto.assunto,
                          "codAssunto",
                          $$v
                        )
                      },
                      expression: "paginaStatus.subAssunto.assunto.codAssunto"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-12 col-xs-12" },
                [
                  _c("g-input", {
                    ref: "refDescricao",
                    attrs: {
                      id: "refDescricao",
                      name: "refDescricao",
                      tipo: "text",
                      etiqueta: "Descrição",
                      validacao: "required | maxlength(100)",
                      tamanho: 100,
                      foco: false,
                      desabilitar: _vm.paginaStatus.desabilitarEdicao
                    },
                    model: {
                      value: _vm.paginaStatus.subAssunto.desSubassunto,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.paginaStatus.subAssunto,
                          "desSubassunto",
                          $$v
                        )
                      },
                      expression: "paginaStatus.subAssunto.desSubassunto"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-xs-5 col-md-5" },
                [
                  _c("g-option", {
                    ref: "refAtivo",
                    attrs: {
                      id: "ativo",
                      name: "ativo",
                      tipo: "radio",
                      option: _vm.arrayAtivoEnum,
                      desabilitar: _vm.paginaStatus.desabilitarEdicao,
                      etiqueta: "Ativo",
                      validacao: "required"
                    },
                    model: {
                      value: _vm.indAtivo,
                      callback: function($$v) {
                        _vm.indAtivo = $$v
                      },
                      expression: "indAtivo"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-xs-5 col-md-5" },
                [
                  _c("g-option", {
                    ref: "toogleVisivelWeb",
                    attrs: {
                      id: "toogleVisivelWeb",
                      name: "toogleVisivelWeb",
                      tipo: "radio",
                      option: _vm.arrayAtivoEnum,
                      desabilitar: _vm.paginaStatus.desabilitarEdicao,
                      etiqueta: "Permite solicitação online",
                      validacao: "required"
                    },
                    model: {
                      value: _vm.indWeb,
                      callback: function($$v) {
                        _vm.indWeb = $$v
                      },
                      expression: "indWeb"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-xs-5 col-md-5" },
                [
                  _c("g-option", {
                    ref: "toogleVisivelWeb",
                    attrs: {
                      id: "toogleVisivelWeb",
                      name: "toogleVisivelWeb",
                      tipo: "radio",
                      option: _vm.arrayAtivoEnum,
                      desabilitar: _vm.paginaStatus.desabilitarEdicao,
                      etiqueta: "Visível no portal de serviços",
                      validacao: "required"
                    },
                    model: {
                      value: _vm.indVisivelPortal,
                      callback: function($$v) {
                        _vm.indVisivelPortal = $$v
                      },
                      expression: "indVisivelPortal"
                    }
                  })
                ],
                1
              )
            ]),
            _c("br"),
            !_vm.desabilitarInformacao
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-sm-12 col-xs-12" },
                    [
                      _c(
                        "q-field",
                        {
                          attrs: {
                            error: _vm.error,
                            "error-label": "Campo obrigatório não informado"
                          }
                        },
                        [
                          _c("q-editor", {
                            ref: "txtInformacaoWeb",
                            attrs: {
                              id: "txtInformacaoWeb",
                              name: "txtInformacaoWeb",
                              readonly: _vm.readonly,
                              validacao: "required",
                              disable: _vm.paginaStatus.desabilitarEdicao,
                              disabilitar: _vm.desabilitarInformacao,
                              toolbar: [
                                [
                                  "bold",
                                  "italic",
                                  "strike",
                                  "underline",
                                  "subscript",
                                  "superscript"
                                ],
                                ["token", "hr", "link", "custom_btn"],
                                ["fullscreen"],
                                [
                                  {
                                    label: _vm.$q.i18n.editor.formatting,
                                    icon: _vm.$q.icon.editor.formatting,
                                    list: "no-icons",
                                    options: [
                                      "p",
                                      "h1",
                                      "h2",
                                      "h3",
                                      "h4",
                                      "h5",
                                      "h6",
                                      "code"
                                    ]
                                  },
                                  {
                                    label: _vm.$q.i18n.editor.fontSize,
                                    icon: _vm.$q.icon.editor.fontSize,
                                    fixedLabel: true,
                                    fixedIcon: true,
                                    list: "no-icons",
                                    options: [
                                      "size-1",
                                      "size-2",
                                      "size-3",
                                      "size-4",
                                      "size-5",
                                      "size-6",
                                      "size-7"
                                    ]
                                  },
                                  {
                                    label: _vm.$q.i18n.editor.defaultFont,
                                    icon: _vm.$q.icon.editor.font,
                                    fixedIcon: true,
                                    list: "no-icons",
                                    options: [
                                      "default_font",
                                      "arial",
                                      "arial_black",
                                      "comic_sans",
                                      "courier_new",
                                      "impact",
                                      "lucida_grande",
                                      "times_new_roman",
                                      "verdana"
                                    ]
                                  },
                                  "removeFormat"
                                ],
                                [
                                  "quote",
                                  "unordered",
                                  "ordered",
                                  "outdent",
                                  "indent"
                                ],
                                [
                                  {
                                    label: _vm.$q.i18n.editor.align,
                                    icon: _vm.$q.icon.editor.align,
                                    fixedLabel: true,
                                    list: "only-icons",
                                    options: [
                                      "left",
                                      "center",
                                      "right",
                                      "justify"
                                    ]
                                  }
                                ],
                                ["undo", "redo"]
                              ],
                              fonts: {
                                arial: "Arial",
                                arial_black: "Arial Black",
                                comic_sans: "Comic Sans MS",
                                courier_new: "Courier New",
                                impact: "Impact",
                                lucida_grande: "Lucida Grande",
                                times_new_roman: "Times New Roman",
                                verdana: "Verdana"
                              }
                            },
                            model: {
                              value: _vm.txtInformacaoWeb,
                              callback: function($$v) {
                                _vm.txtInformacaoWeb = $$v
                              },
                              expression: "txtInformacaoWeb"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-12 text-right pad-20t-h10-80b" },
        [
          _c(
            "q-btn",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.paginaStatus.desabilitarEdicao,
                  expression: "!paginaStatus.desabilitarEdicao"
                }
              ],
              staticClass: "fixed",
              staticStyle: { right: "18px", bottom: "18px" },
              attrs: {
                round: "",
                id: "btnSalvar",
                name: "btnSalvar",
                color: "positive",
                icon: "check",
                size: "lg"
              },
              on: { click: _vm.salvar }
            },
            [_c("q-tooltip", [_vm._v("Salvar")])],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }